var acExpandable = acExpandable || {};
var lazyLoader = require("luminoslabs/_lazy-loading");

if (!Object.create) {
    Object.create = (function () {
        function F() {}

        return function (o) {
            if (arguments.length != 1) {
                throw new Error('Object.create implementation only accepts one parameter.');
            }
            F.prototype = o;
            return new F()
        }
    })()
}

jQuery(function ( $ ) {

    $.fn.acExpand = function( options ) {
        return this.each(function() {
            var acExpand = Object.create(acExpandable.acExpand);
            acExpand.init(this, options);
        });
    };

    $.fn.acExpand.options = {
     };

    acExpandable.acExpand = {


        init (elem, options) {
            var self = this;
            self.$container = $(elem);
            self.$section = self.$container.find(".expandable-section");
            self.$link = self.$section.find(".drawer-trigger");
            self.$drawer = self.$section.find(".drawer");
            self.$social = self.$drawer.find(".social-module--drawer");
            self.$slideshow = self.$section.find('.mm-slideshow');

            self.$slideshow.removeClass('initialized');

            self.bindElements();
        },

        bindElements () {
            var self = this;

            self.$link.on("click", function() {
                var active = $(this).parent( self.$section );
                $(active).toggleClass("drawer-open").find( self.$drawer ).slideToggle(200, function() {
                    // $('.slick-slider').get(0).slick.setPosition()
                    $(active).find('.slick-slider').slick('setPosition');
                    $(active).find('.mm-slideshow').toggleClass('initialized');
                });

                lazyLoader.revalidate();

                self.toggleIcon( $(this).find(".drawer-trigger__icon use") );

                if (typeof window.maps !== 'undefined') {
                    for (var i = 0; i < window.maps.length; i++) {
                        window.maps[i].resize();
                    }
                }

                return false;
            });

            // Allows for Hash to define open drawer and scrolls to location
            !!window.location.hash && self.urlTrigger( window.location.hash.replace("#", '') )
        },

        toggleIcon (target) {
            var toggle = $(target).attr("xlink:href") === '#plus-o' ? "#minus-o" : "#plus-o"
            $(target).attr("xlink:href", toggle)
        },

        urlTrigger (location) {
            var self = this;
            var active = $("[data-section="+ location +"]")
            $( active ).toggleClass("drawer-open").find( self.$drawer ).slideToggle(400,   self.setWaypoints( active ) );
            self.toggleIcon( $( active ).find(".drawer-trigger__icon use") );
                $('html, body').animate({
                    scrollTop: $(active).offset().top - 60
                }, 1000);

        },
        setWaypoints( section ) {
            var self = this;

            // var waypoints = self.$drawer.waypoint(function(direction) {

            //     if ( direction === 'up') {
            //         self.$drawer.find(".social-module--drawer").removeClass("social-fixed")
            //         self.$drawer.find(".b2t--drawer").fadeOut("fast")

            //     } else {
            //         self.$drawer.find(".social-module--drawer").addClass("social-fixed")
            //         self.$drawer.find(".b2t--drawer").fadeIn("fast")

            //     }
            // }, {
            //     offset: "60px"
            // });


            // var waypoints = self.$drawer.waypoint(function(direction) {

            //     if ( direction === 'up') {
            //         self.$section.find(".social-module--drawer").addClass("social-fixed")
            //         self.$drawer.find(".b2t--drawer").fadeIn("fast")
            //     } else {
            //         self.$section.find(".social-module--drawer").removeClass("social-fixed")
            //         self.$drawer.find(".b2t--drawer").fadeOut("fast")

            //     }
            // }, {
            //     offset: "bottom-in-view"
            // });

        }
    };
});
